var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoposter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5009:47296)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00136e-05 1.43182C1.00136e-05 0.641047 0.6506 0 1.45313 0H30.5469C31.3494 0 32 0.641046 32 1.43182L32 16.5681C32 17.3589 31.3494 17.9999 30.5469 17.9999H1.45317C0.650627 17.9999 3.71933e-05 17.3589 3.71933e-05 16.5681L1.00136e-05 1.43182ZM1.45313 0.954545C1.18562 0.954545 0.96876 1.16823 0.96876 1.43182L0.968787 16.5681C0.968787 16.8317 1.18565 17.0454 1.45317 17.0454H30.5469C30.8144 17.0454 31.0312 16.8317 31.0312 16.5681L31.0312 1.43182C31.0312 1.16823 30.8144 0.954545 30.5469 0.954545H1.45313Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1001 6.14954C13.1001 5.75765 13.5521 5.51879 13.9005 5.72663L18.6669 8.57031C18.9946 8.76581 18.9944 9.22111 18.6666 9.41641L13.9001 12.2552C13.5517 12.4627 13.1001 12.2238 13.1001 11.8321V6.14954Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5009:47296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoposter);
export default __webpack_public_path__ + "static/media/videoposter.c1981fd37c30368cf77d5cd877efbf0e.svg";
export { ForwardRef as ReactComponent };